/*  MUI  */
import { Box, LinearProgress, Typography } from '@mui/material';
import { CellContext } from '@tanstack/react-table';

/* Shared */
import { Helpers } from 'application/Shared/Helpers';
import { ClientLink } from 'application/Shared/types/clientLink';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/* Internal */
import { usePartnerClientsTableContext } from './PartnerClientsTableContext';

const { isset, isEmpty } = Helpers;

export const ClientApplicationsCell = ({
    row
}: CellContext<ClientLink, unknown>) => {
    const { t } = useTranslation();
    const { id } = row.original;
    const { clientApps } = usePartnerClientsTableContext();

    let classified = 0;
    let unclassified = 0;
    let totalApps = 0;
    if (isset(clientApps, id)) {
        const appData = clientApps[id];
        const { uniqueClientApplications, applicationBreakdown } = appData;

        totalApps = uniqueClientApplications ?? 0;
        if (!isEmpty(applicationBreakdown)) {
            classified = applicationBreakdown?.classified ?? 0;
            unclassified = applicationBreakdown?.unclassified ?? 0;
        }
    }

    return (
        <Box
            display="flex"
            alignItems="center"
            data-testid="clientApplicationsCell"
        >
            <Box flex={1}>
                <LinearProgress
                    data-testid="clientAppCellLinearProgress"
                    value={
                        100 - (unclassified / (classified + unclassified)) * 100
                    }
                    variant="determinate"
                />
                <Box
                    data-testid="clientAppCellClassified"
                    style={{ marginTop: '2px' }}
                >
                    {t('Partner.dashboard.number_classified', {
                        classified
                    })}
                </Box>
                <Box data-testid="clientAppCellUnclassified">
                    {t('Partner.dashboard.number_unclassified', {
                        unclassified
                    })}
                </Box>
            </Box>
            <Box ml="32px">
                <Typography
                    data-testid="clientAppCellTotal"
                    style={{ fontWeight: 600 }}
                >
                    {t('Partner.dashboard.number_total', { totalApps })}
                </Typography>
            </Box>
        </Box>
    );
};
